import React from "react";

// Logo de check-in: una marca de verificación sobre el turquesa de marca (Pantone P 130-13 C, #20B2A1).
export default function Logo({ className = "", titulo = "" }) {
  return (
    <svg className={className} viewBox="0 0 64 64" role={titulo ? "img" : "presentation"} aria-label={titulo || undefined} aria-hidden={titulo ? undefined : true}>
      <defs>
        <linearGradient id="ci-logo-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3fd0bf" />
          <stop offset="1" stopColor="#20b2a1" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="18" fill="url(#ci-logo-g)" />
      <path d="M18 33.5l9.5 9.5L46.5 22" fill="none" stroke="#fff" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
